import { styled } from "@mui/material";
import { Form as UnstyledForm } from "formik";

export const Form = styled(UnstyledForm)({
  display: "none",
});
